import axios from "axios";
import { getToken } from "./auth";
import router from "../router/index"; // 引入userRouter
import { ElMessage } from "element-plus";
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // api的base_url
  timeout: 1500000, // 请求超时时间2
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (getToken("token")) {
      config.headers.Authorization = getToken("token");
    } else {
      router.push("/login");
    }
    if (
      config.url == "/flowable/task/export" ||
      config.url == "/flowable/task/exportBoarding" ||
      config.url == "/flowable/task/exportApplication" ||
      config.url == "/flowable/task/exportInternalReferral" ||
      config.url == "/stars/config/benchmark-position/export" ||
      config.url == "/stars/config/city/export" ||
      config.url == "/stars/config/dept/export" ||
      config.url == "/stars/config/dept/importData" ||
      config.url == "/stars/config/city/importData" ||
      config.url == "/stars/position/exportPostion" ||
      config.url == "/stars/config/importTemplate/dept" ||
      config.url == "/stars/config/importTemplate/city" ||
      config.url == "/stars/candidate/exportCandidate" ||
      config.url == "/stars/talent-pool/export"
    ) {
      config.responseType = "blob";
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.error(error); // for debug
    Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code == 401) {
      router.push("/login");
      // 如果服务token过期或者无效提示
      localStorage.removeItem('token')
      ElMessage.closeAll()
      // ElMessage({
      //   message: 'Login timeout, please log in again',
      //   type: "error",
      //   duration: 3 * 1000,
      // });
    }
    return Promise.resolve(res);
  },
  (error) => {
    console.error("err" + error); // for debug
    ElMessage({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
